/* BIRGAMO V32 — accessibility and interaction reliability layer. */
(function () {
  'use strict';

  function focusableNodes(container) {
    return Array.prototype.slice.call(container.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (node) {
      return !node.hidden && node.offsetParent !== null;
    });
  }

  function getOpenDialog() {
    var media = document.querySelector('[data-product-media-modal]');
    if (media && !media.hidden) return media.querySelector('[role="dialog"]') || media;

    var guide = document.querySelector('[data-size-guide-modal]');
    if (guide && !guide.hidden) return guide.querySelector('[role="dialog"]') || guide;

    var cart = document.querySelector('[data-cart-drawer]');
    if (cart && cart.getAttribute('aria-hidden') === 'false') return cart;
    return null;
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Tab') return;
    var dialog = getOpenDialog();
    if (!dialog) return;

    var nodes = focusableNodes(dialog);
    if (!nodes.length) {
      event.preventDefault();
      dialog.focus();
      return;
    }

    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  function initMobileStickyAddToBag() {
    var root = document.querySelector('[data-product-root]');
    var bar = document.querySelector('[data-sticky-atc-bar]');
    if (!root || !bar || !('IntersectionObserver' in window)) return;

    var form = root.querySelector('[data-product-form]') || root.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    function setVisible(visible) {
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');

      var whatsapp = document.querySelector('.whatsapp-float');
      if (whatsapp) {
        var offset = visible ? Math.ceil(bar.getBoundingClientRect().height) : 0;
        whatsapp.style.setProperty('--whatsapp-atc-offset', offset + 'px');
      }
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0.05 });

    observer.observe(form);
  }

  function initProductGalleryThumbnails() {
    document.querySelectorAll('[data-product-gallery-thumb]').forEach(function (thumb) {
      if (thumb.dataset.birgamoThumbReady === 'true') return;
      thumb.dataset.birgamoThumbReady = 'true';
      thumb.addEventListener('click', function () {
        var index = thumb.getAttribute('data-product-gallery-index');
        var opener = document.querySelector('[data-product-gallery-open][data-product-gallery-index="' + index + '"]');
        document.querySelectorAll('[data-product-gallery-thumb]').forEach(function (item) {
          item.classList.toggle('is-active', item === thumb);
        });
        if (opener) opener.click();
      });
    });
  }

  function focusCartAfterOpen() {
    var cart = document.querySelector('[data-cart-drawer]');
    if (!cart || cart.dataset.birgamoFocusReady === 'true') return;
    cart.dataset.birgamoFocusReady = 'true';

    new MutationObserver(function () {
      if (cart.getAttribute('aria-hidden') !== 'false') return;
      window.setTimeout(function () {
        var close = cart.querySelector('[data-cart-close]');
        if (close) close.focus();
      }, 40);
    }).observe(cart, { attributes: true, attributeFilter: ['aria-hidden'] });
  }

  function init() {
    initMobileStickyAddToBag();
    initProductGalleryThumbnails();
    focusCartAfterOpen();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
}());
